module.exports = __webpack_public_path__ + "img/47_16.9840b8b1.png";